import { useAppContext } from '@/context';
import { logout, updateUserInStorage } from '@/utils/auth';
import { patchJson } from '@/utils/fetchOptions';

import { useAuth, useAuthToken } from './useAuth';
import { useMutation } from './useMutation';

interface UseTeamUpdateProps {
  onSuccess: TypeAny;
  teamId: string;
  name: string;
}

export function useTeamUpdate({ onSuccess, teamId, name }: UseTeamUpdateProps) {
  const { authData, setAuthData } = useAuth();
  const { setAlert } = useAppContext();
  const token = useAuthToken();

  const {
    isLoading,
    data = {},
    mutate,
    error
  } = useMutation({
    mutationKey: 'team-update',
    mutationFn: async () =>
      patchJson({
        url: `${process.env.NEXT_PUBLIC_BEATLY_API_URL}/app/v2/team/${teamId}/update`,
        body: { name },
        token
      }).then((response: Api.Team | ResponseObject) => {
        if ((response as ResponseExpiredToken).isExpired) {
          logout();
        }

        if ('code' in response) {
          setAlert(response.code);
          return {};
        }

        const updatedUser = {
          ...authData?.user,
          team: response
        };

        updateUserInStorage(updatedUser);
        setAuthData({ ...authData, user: updatedUser });

        return response;
      }),
    onSuccess
  });

  return {
    isLoading,
    mutate,
    error,
    data
  };
}
